import { isJsObject } from "@util/utils";

export const enum MediaCaptureTypes {
  IMAGE = 'image',
  VIDEO = 'video'
};

export function findBestFit(
  imageWidthIn: number,
  imageHeightIn: number,
  scale: any,
  onlyBoundingBox = false
) {
  const result: any = {
    widthIn: imageHeightIn,
    heightIn: imageHeightIn,
    width: imageWidthIn,
    height: imageHeightIn
  };

  if (isJsObject(scale) && scale.width && scale.height) {
    let scaleMax = Math.max(scale.width, scale.height);
    let scaleMin = Math.min(scale.width, scale.height);

    let inMax = Math.max(imageWidthIn, imageHeightIn);
    let inMin = Math.min(imageWidthIn, imageHeightIn);

    if (inMax > scaleMax || inMin > scaleMin) {
      result.width = scaleMax;
      result.height = scaleMin;

      if (imageWidthIn < imageHeightIn) {
        result.width = scaleMin;
        result.height = scaleMax;
      }

      if (onlyBoundingBox) {
        return result;
      }

      if (imageWidthIn > result.width || imageHeightIn > result.height) {
        const scaleWidth = result.width / imageWidthIn;
        const scaleHeight = result.height / imageHeightIn;

        if (scaleWidth < scaleHeight) {
          result.height = scaleWidth * imageHeightIn;
        } else {
          result.width = scaleHeight * imageWidthIn;
        }
        const scale = Math.min(scaleHeight, scaleWidth);
        result.scale = scale;
        result.scaleW = scaleWidth;
        result.scaleH = scaleHeight;
      }
    }
  }
  return result;
}
